import { getAuthUrl } from "@artists/devkit"
import { Confirm } from "@artists/uikit"
import { Button } from "@mui/material"
import { useCallback } from "react"
import { useTranslation } from "react-i18next"

import { getENV } from "../../../../../@common"
import {
	CreateAccountCallToAction,
	createNewAccountAnalytics,
	useAnalytics,
} from "../../../../utils"

interface FraudPromptProps {
	slug: string
	withCaptchaError?: boolean
	withIpError?: boolean
}

export const FraudPrompt = ({
	withCaptchaError,
	withIpError,
	slug,
}: FraudPromptProps) => {
	const { t } = useTranslation("vote")
	const { title, primaryButton, text, secondaryButton } = t(
		withIpError ? "warnings.ipFraudCheck" : "warnings.captchaFraudCheck",
		{
			returnObjects: true,
		},
	)
	const { send } = useAnalytics()

	const onAuthClick = useCallback(() => {
		window.location.assign(
			getAuthUrl({
				host: getENV("SPOONFLOWER_HOST"),
				fallbackUrl: window.location.href,
			}),
		)
	}, [])

	const onSignUpClick = useCallback(() => {
		const analytics = createNewAccountAnalytics(
			withIpError
				? CreateAccountCallToAction.IP_FRAUD
				: CreateAccountCallToAction.CAPTCHA_ERROR,
			slug,
		)
		send(analytics)

		window.location.assign(
			getAuthUrl({
				action: "register",
				host: getENV("SPOONFLOWER_HOST"),
				fallbackUrl: window.location.href,
			}),
		)
	}, [send, slug, withIpError])

	return (
		<Confirm
			showCloseIcon={false}
			open={Boolean(withCaptchaError || withIpError)}
			title={title}
			subtitle={text}
			confirmText={primaryButton}
			actions={[
				<Button
					color='secondary'
					variant='contained'
					onClick={onAuthClick}
					sx={{ textTransform: "none" }}
				>
					{primaryButton}
				</Button>,
				<Button
					color='secondary'
					variant='contained'
					onClick={onSignUpClick}
					sx={{ textTransform: "none" }}
				>
					{secondaryButton}
				</Button>,
			]}
		/>
	)
}
